import { createContext } from 'react';

export interface PlanLimitsContextValue {
  plan: string | undefined;
  status: string | undefined;
  expiresAt?: string;
  limits: Record<string, unknown> | undefined;
  isLoading: boolean;
}

export const PlanLimitsContext = createContext<
  PlanLimitsContextValue | undefined
>(undefined);
